// extracted by mini-css-extract-plugin
module.exports = {"truncate":"EventCard_truncate_2SVZb","statusIndicator":"EventCard_statusIndicator_qDAmA"};